import "./SectionDivider.css";

export default function SectionDivider() {
  return (
    <div className="section-divider">
      <span className="section-divider__line" />
      <span className="section-divider__dot" />
      <span className="section-divider__line" />
    </div>
  );
}
